var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPlay = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 84,
  height: 84,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#play_svg__a)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 76,
  height: 76,
  x: 4,
  y: 4,
  fill: "url(#play_svg__b)",
  rx: 38
}), /*#__PURE__*/React.createElement("rect", {
  width: 80,
  height: 80,
  x: 2,
  y: 2,
  stroke: "#fff",
  strokeOpacity: 0.2,
  strokeWidth: 4,
  rx: 40
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m55.441 37.916-19.316-11.16a3.63 3.63 0 0 0-1.822-.506 3.803 3.803 0 0 0-3.803 3.802v23.952a3.746 3.746 0 0 0 5.737 3.172l19.34-12.217a4.107 4.107 0 0 0-.136-7.043"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "play_svg__b",
  x1: 4,
  x2: 104.844,
  y1: 42.384,
  y2: 44.506,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C830E1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FE4A25"
})), /*#__PURE__*/React.createElement("filter", {
  id: "play_svg__a",
  width: 104,
  height: 104,
  x: -10,
  y: -10,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "BackgroundImageFix",
  stdDeviation: 5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "SourceAlpha",
  operator: "in",
  result: "effect1_backgroundBlur_20508_14292"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_backgroundBlur_20508_14292",
  result: "shape"
})))));
export { SvgPlay as ReactComponent };
export default __webpack_public_path__ + "static/media/play.f37dc643.svg";